import type { ServicioConClientes } from '@/services/serviciosService'
import { PERIODICIDAD_SERVICIO_LABELS, type PeriodicidadServicio } from '@/types/database'

// Orden de negocio de las secciones: primero lo que genera honorarios recurrentes
// (motor de honorarios: cuanto más corto el ciclo, antes aparece), "segun_vencimiento"
// como recurrente sin ciclo fijo, y al final lo que es a presupuesto (unico, no_aplica).
const ORDEN_PERIODICIDAD: readonly PeriodicidadServicio[] = [
  'mensual',
  'bimestral',
  'trimestral',
  'cuatrimestral',
  'semestral',
  'anual',
  'segun_vencimiento',
  'unico',
  'no_aplica',
]

export const SIN_PERIODICIDAD = '__sin_periodicidad__' as const

export interface GrupoServicios {
  key: string
  label: string
  servicios: ServicioConClientes[]
}

/**
 * Agrupa los servicios ya filtrados por periodicidad, en el orden de ORDEN_PERIODICIDAD.
 * Un servicio sin periodicidad cargada cae en un grupo aparte al final.
 */
export const agruparPorPeriodicidad = (
  servicios: ServicioConClientes[]
): GrupoServicios[] => {
  const porPeriodicidad = new Map<string, ServicioConClientes[]>()
  for (const servicio of servicios) {
    const periodicidad = (servicio as { periodicidad?: PeriodicidadServicio | null }).periodicidad
    const key = periodicidad ?? SIN_PERIODICIDAD
    const lista = porPeriodicidad.get(key)
    if (lista) {
      lista.push(servicio)
    } else {
      porPeriodicidad.set(key, [servicio])
    }
  }

  const grupos: GrupoServicios[] = []
  for (const key of [...ORDEN_PERIODICIDAD, SIN_PERIODICIDAD]) {
    const lista = porPeriodicidad.get(key)
    if (!lista) continue
    grupos.push({
      key,
      label: key === SIN_PERIODICIDAD ? 'Sin periodicidad' : PERIODICIDAD_SERVICIO_LABELS[key],
      servicios: lista,
    })
    porPeriodicidad.delete(key)
  }

  // Periodicidad cargada pero fuera del orden conocido: se muestra igual, al final,
  // con la clave cruda como label.
  for (const [key, lista] of porPeriodicidad) {
    grupos.push({ key, label: key, servicios: lista })
  }

  return grupos
}
